import $ from 'jquery';
import { sendCartDrawerOpenRequestEvent } from '../../core/notifications/cart-drawer-open-request';
import { sendProductVariantSelectedEvent } from '../../core/notifications/product-variant-selected';
import { load as loadProductOptions } from '../../core/product-options';
import { formatMoney } from '../../core/shopify/format-money';
import { SingleItemPayload } from '../../core/cart/machine/context/add-items-to-cart/payload';
import { getCartMachine } from '../../core/cart';
import { createRawItemPayload } from '../../core/cart/create-raw-item-payload';
import { ProductDetailsIO } from './io';
const soldOutMessage = 'Sold Out';
const addCollectionLineItemProperty = (form, collectionTitle)=>{
    if (!form || !collectionTitle) return;
    const inputName = 'properties[_collection]';
    let input = form.find(`input[name="${inputName}"]`);
    if (input.length === 0) {
        input = $('<input>').attr('type', 'hidden').attr('name', inputName).val(collectionTitle);
        form.append(input);
    } else {
        input.val(collectionTitle);
    }
};
export const init = async function() {
    const cartMachine = getCartMachine();
    const containers = $('.js-product-details');
    let col_title = '';
    let col_handle = '';
    const el = $('.js-pdpsmpcol');
    if (el) {
        col_title = el.attr('data-collection') || '';
        col_handle = el.attr('data-collection-handle') || '';
    }
    const tooltip = document.querySelectorAll('.js-product-salelabel');
    const tooltip_close = document.querySelectorAll('.js-product-salelabel-close');
    const tooltip_el = tooltip.forEach((ele)=>{
        ele.addEventListener('click', function(evt) {
            const panel = ele.nextElementSibling;
            if (panel === null) {
                return;
            }
            $(panel).addClass('--show');
        });
    });
    const tooltip_elclose = tooltip_close.forEach((ele)=>{
        ele.addEventListener('click', function(evt) {
            const parent = ele.parentElement;
            if (parent === null) {
                return;
            }
            $(parent).removeClass('--show');
        });
    });
    containers.each(function(_, cElement) {
        const container = $(cElement);
        const errorRenderTarget = container.find('.js-product-form-error');
        const addToCartForm = container.find('form[action^="/cart/add"]');
        const rawIo = container.find('script[type="application/json"]').first().text() || '{}';
        const { currencyCode , moneyFormat , sale , collection  } = ProductDetailsIO.create(JSON.parse(rawIo));
        const selectCallback = function({ product: { id: productId  } , selectedVariant: variant  }) {
            const formattedPrice = formatMoney(variant.price, moneyFormat);
            const price = !variant.available ? [
                /*'<del>',*/ formattedPrice /*,
            '</del>',
            '<strong>',
            soldOutMessage,
            '</strong>'*/ 
            ].join(' ') : variant.compare_at_price && variant.price < variant.compare_at_price ? [
                formattedPrice,
                '<del>',
                formatMoney(variant.compare_at_price, moneyFormat),
                '</del>'
            ].join(' ') : formattedPrice;
            container.find('.js-price-preview').html(price);
            addToCartForm.find('[type="submit"]').prop('disabled', !variant.available);
            container.find('#js-add-to-cart').css('display', variant.available ? 'block' : 'none').attr('data-variant-available', variant.available.toString());
            container.find('.js-variant-selector-dummy').val(variant.id).trigger('change');
            // Update hidden input for variant ID
            const isOnSale = sale.enabled && sale.variantsMap[variant.id] === true;
            const propertyName = 'properties[Sale]';
            const existing = addToCartForm.find(`input[name="${propertyName}"]`);
            if (isOnSale) {
                if (!existing.length) {
                    $('<input>', {
                        type: 'hidden',
                        name: propertyName,
                        value: sale.suffix
                    }).appendTo(addToCartForm);
                } else {
                    existing.val(sale.suffix);
                }
            } else {
                if (existing.length) existing.remove();
            }
            if (collection) {
                addCollectionLineItemProperty(addToCartForm, collection);
            }
            errorRenderTarget.empty();
            sendProductVariantSelectedEvent({
                productId,
                variantId: variant.id
            });
        };
        if (col_title !== '') {
            $('.js-pdp-breadcrumb-col').attr('href', col_handle);
            $('.js-pdp-breadcrumb-col').html(col_title);
            $('.js-pdp-breadcrumb-col').css('display', 'inline-block');
        } else {
            $('.js-pdp-breadcrumb-col').css('display', 'none');
            $('.js-pdp-breadcrumb-item').css('display', 'none');
        }
        addToCartForm.on('submit', async function(evt) {
            evt.preventDefault();
            try {
                var _document_querySelectorAll_;
                const form = $(evt.delegateTarget);
                const rawItemPayload = createRawItemPayload(form.serializeArray());
                const itemPayload = SingleItemPayload.create(rawItemPayload);
                errorRenderTarget.empty();
                const itemsAddedToCart = await new Promise(function(resolve, reject) {
                    cartMachine.addItems({
                        resolve,
                        reject,
                        input: {
                            items: [
                                itemPayload
                            ]
                        }
                    });
                });
                // TODO: Use `itemsAddedToCart` data to render notification widgets
                // eslint-disable-next-line no-console
                if (itemsAddedToCart) {
                    const products = [];
                    itemsAddedToCart.items.forEach((lineItem)=>{
                        let variantName = '';
                        if (lineItem.variant_options) {
                            variantName = Object.values(lineItem.variant_options).join(' / ');
                        }
                        var _lineItem_sku, _lineItem_product_type, _lineItem_product_title;
                        products.push({
                            sku: (_lineItem_sku = lineItem.sku) !== null && _lineItem_sku !== void 0 ? _lineItem_sku : 'Unknown',
                            productType: (_lineItem_product_type = lineItem.product_type) !== null && _lineItem_product_type !== void 0 ? _lineItem_product_type : 'Unknown',
                            name: (_lineItem_product_title = lineItem.product_title) !== null && _lineItem_product_title !== void 0 ? _lineItem_product_title : 'Unknown',
                            price: lineItem.price,
                            quantity: 1,
                            variantName: `${lineItem.product_title} - ${variantName}`,
                            collectionName: collection !== null && collection !== void 0 ? collection : 'Unknown'
                        });
                    });
                    const isCartPage = document.body.getAttribute('data-shopify-template') === 'cart';
                    const eventSource = isCartPage ? 'cart_page' : 'mini_cart';
                    Shopify.analytics.publish('add_to_cart', {
                        event: 'Add to Cart',
                        productsToAdd: products,
                        source: eventSource
                    });
                }
                const enableAjaxCart = (_document_querySelectorAll_ = document.querySelectorAll('[data-ajax-cart-disabled]')[0]) === null || _document_querySelectorAll_ === void 0 ? void 0 : _document_querySelectorAll_.getAttribute('data-ajax-cart-disabled');
                const feedback = document.querySelector('.Header-addedBanner');
                const feedbackMobile = document.querySelector('.HeaderMobile-addedBanner');
                if (enableAjaxCart === 'disabled') {
                    if (feedback !== null && feedback instanceof HTMLElement) {
                        feedback.style.transform = 'translateX(0%)';
                    }
                    if (feedbackMobile !== null && feedbackMobile instanceof HTMLElement) {
                        feedbackMobile.style.transform = 'translateX(0%)';
                    }
                    setTimeout(()=>{
                        if (feedback !== null && feedback instanceof HTMLElement) {
                            feedback.style.transform = 'translateX(-100%)';
                        }
                        if (feedbackMobile !== null && feedbackMobile instanceof HTMLElement) {
                            feedbackMobile.style.transform = 'translateX(-100%)';
                        }
                    }, 2500);
                } else {
                    sendCartDrawerOpenRequestEvent();
                }
            } catch (err) {
                const msgSuffix = '[a8bed63b434340e982acf019d921f602]';
                const errMessage = err instanceof Error ? err.message : typeof err === 'string' ? err : 'Unknown error';
                errorRenderTarget.text(errMessage);
            }
        });
        const optionsContainer = container.find('.js-product-options');
        const optionsContainerElement = optionsContainer.get(0);
        if (!optionsContainerElement) {
            return;
        }
        loadProductOptions(optionsContainerElement, selectCallback);
    });
};
